import { environment } from '../../../environments/environment';
import { EphemeralTokenConfig } from './ephemeral-token.interface';

/**
 * Configuración del sistema de tokens efímeros
 * 
 * IMPORTANTE: Este sistema está implementado pero NO activado.
 * Para activarlo, registra el interceptor en app.module.ts:
 * 
 * providers: [
 *   { provide: HTTP_INTERCEPTORS, useClass: EphemeralTokenInterceptor, multi: true }
 * ]
 */
export const EPHEMERAL_TOKEN_CONFIG: EphemeralTokenConfig = {
  // URL del backend de seguridad desde environment
  securityApiUrl: environment.backendUrl,

  // Endpoint para obtener token efímero
  tokenEndpoint: '/auth/webform/token',

  // Endpoint de suscripción en servidor de seguridad
  subscriptionEndpoint: '/suscription',

  // TTL del token: 3 minutos (180 segundos)
  ttl: 180,

  // Habilitar reintento automático si el token expira
  enableAutoRetry: true,

  // Máximo 1 reintento según especificación
  maxRetries: 1
};

/**
 * Helper para determinar si una URL requiere token efímero
 */
export function requiresEphemeralToken(url: string): boolean {
  // ⚠️ CRÍTICO: No interceptar la petición para obtener el token (evitar loop infinito)
  if (url.includes('/auth/webform/token')) {
    return false;
  }
  
  // ✅ /public-key SÍ requiere token efímero (backend requiere autenticación)
  // Comentado para permitir interceptación
  // if (url.includes('/public-key')) {
  //   return false;
  // }
  
  // No interceptar endpoints que no requieren autenticación
  if (url.includes('/log')) {
    return false;
  }
  
  // No interceptar recursos estáticos (assets, traducciones, imágenes, etc.)
  if (url.includes('/assets/') || 
      url.includes('/i18n/') || 
      url.endsWith('.json') ||
      url.endsWith('.svg') ||
      url.endsWith('.png') ||
      url.endsWith('.jpg') ||
      url.endsWith('.jpeg') ||
      url.endsWith('.gif') ||
      url.endsWith('.ico') ||
      url.endsWith('.css') ||
      url.endsWith('.js') ||
      url.endsWith('.woff') ||
      url.endsWith('.woff2') ||
      url.endsWith('.ttf') ||
      url.endsWith('.eot')) {
    return false;
  }
  
  // Todas las demás peticiones API requieren token efímero
  return true;
}

/**
 * Helper para obtener la URL completa del endpoint de seguridad
 */
export function getSecurityEndpointUrl(endpoint: string): string {
  return `${EPHEMERAL_TOKEN_CONFIG.securityApiUrl}${endpoint}`;
}
